import {useState} from "react";

import {Spin} from "antd";

import {AntdTable} from "@/components/custom/AntdTable/AntdTable.jsx";
import {Maintenance, MaintenanceSwitcher} from "@/components/custom/MaintenanceSwitcher/MaintenanceSwitcher.jsx";
import {Usage} from "@/variants/index.js";

export const UsageTab = ({usageInfo, onUsageChange, loading}) => {
	const [maintenanceFilter, setMaintenanceFilter] = useState(Maintenance.PM_CM);

	function getCurrentDateInfo() {
		const now = new Date();
		return {
			now,
			currentYear: now.getFullYear(),
			currentMonth: now.getMonth() + 1,
		};
	}

	function handleChange(maintenanceValue) {
		setMaintenanceFilter(maintenanceValue);
		onUsageChange(maintenanceValue);
	}

	function getColumns() {
		const {currentYear, currentMonth} = getCurrentDateInfo();

		const columns = [
			{
				key: "year",
				title: <b>Year</b>,
				dataIndex: "year",
				render: year => <b>{year}</b>,
			},
			{
				key: "total",
				title: <b>Total</b>,
				dataIndex: "total",
			},
		];

		const monthsColumns = usageInfo.months.map(m => ({
			key: m,
			title: <b>{m}</b>,
			dataIndex: m,
			render: val => (val ? val : ""),
		}));

		monthsColumns.push({
			key: "demand",
			title: <b>Average Use</b>,
			dataIndex: "total",
			render: (total, item) => {
				const monthsToDivide = item.year === currentYear ? currentMonth : 12;
				return Math.round((!item.av ? total / monthsToDivide : item.av) * 100) / 100;
			},
		});

		return [...columns, ...monthsColumns];
	}

	function getMonthTotal() {
		const result = {};
		for (const m of usageInfo.months) {
			result[m] = [...usageInfo.stats].map(v => parseInt(v[m] || 0)).reduce((a, b) => a + b, 0);
		}
		return result;
	}

	function getRows() {
		const {currentYear, currentMonth} = getCurrentDateInfo();
		const rows = [...usageInfo.stats];
		const monthTotal = getMonthTotal();

		let monthsSinceCreation =
			(currentYear - usageInfo.creationDate.getFullYear()) * 12 +
			(getCurrentDateInfo().now.getMonth() - usageInfo.creationDate.getMonth());

		let total = {
			year: Usage.totalRowLabel,
			total: rows.map(v => parseFloat(v.total || 0)).reduce((a, b) => a + b, 0),
			av: rows.map(v => parseFloat(v.total || 0)).reduce((a, b) => a + b, 0) / monthsSinceCreation,
		};
		total = {...total, ...monthTotal};

		rows.push(total);
		return rows;
	}

	return (
		<>
			<MaintenanceSwitcher value={maintenanceFilter} onChange={handleChange} />
			<Spin spinning={loading}>
				<AntdTable
					tableSize={"small"}
					scroll={300}
					data={getRows()}
					columns={getColumns()}
					data-testid="usage-table"
				/>
			</Spin>
		</>
	);
};
